import React from 'react'
import type { Icon } from 'shared/utils'

const Crown = (props: Icon) => {
    const {
        className = 'crown',
        color = 'white',
        size = 24,
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            fill={color}
            className={className}
            viewBox="0 0 24 24"
            preserveAspectRatio="none"
            {...otherProps}>
            <path
                d="M12.34 15.874c4.993 0 8.375 1.167 8.965 2.106-.94 1.28-4.59 2.22-8.964 2.22-4.375 0-8.053-.94-8.965-2.22.59-.939 3.945-2.106 8.965-2.106zM12.26 4.15c.134-.199.403-.199.537 0l3.704 6.347c.107.17.322.227.483.085l4.026-3.586c.188-.199.51-.028.51.256v9.534c-1.637-1.366-5.368-2.05-9.206-2.05-3.704 0-7.596.77-9.314 2.05V7.25c0-.284.295-.455.51-.284l4.402 3.728c.134.114.349.085.456-.086l3.892-6.46z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Crown }
